const ROUTES = {
  ERROR404: {
    name: 'Error',
    pathname: '/error404',
  },

  LOGIN: {
    pathname: '/login',
  },

  LOGIN_CALLBACK: { pathname: '/login-callback' },
  SEARCH: { pathname: '/search' },

  HOME: {
    name: 'Inicio',
    pathname: '/',
    icon: 'gg:home',
  },

  FORMULARIOS: {
    name: 'Registrar Formulario de Pre-elegibilidad',
    pathname: '/',
  },

  REGISTRAR: {
    name: 'Registrar Formulario de Pre-elegibilidad',
    pathname: '/formularios/registrar',
    roles: ['MIPYME'],
  },

  REGISTRAR_ELEGIBILIDAD: {
    name: 'Registrar Formulario de Elegibilidad',
    pathname: '/formularios/RegistrarElegibilidad',
    roles: ['MIPYME'],
  },
  EDITARELEGIBILIDAD: {
    name: 'Editar Elegibilidad',
    pathname: '/formularios/EditarElegibilidad',
    roles: ['MIPYME'],
  },

  VISTA: {
    name: 'Formularios Enviados',
    pathname: '/formularios/vista',
    roles: ['MIPYME'],
  },

  CONSTRUCTION: {
    pathname: '/construction',
  },

  DETALLES: {
    name: 'Detalles De Formulario',
    pathname: '/formularios/vista/detalles',
    roles: ['MIPYME'],
  },

  DETALLESELEGIBILIDAD: {
    name: 'Detalles De Formulario De Elegibilidad',
    pathname: '/formularios/elegibilidad/vista/',
    roles: ['MIPYME', 'IFI'],
  },

  BORRADORELEGIBILIDAD: {
    name: 'Formularios no Enviados',
    pathname: '/formularios/borrador',
    roles: ['MIPYME'],
  },

  EDITAR: {
    name: 'Formularios a completar',
    pathname: '/formularios/editar',
    roles: ['MIPYME'],
  },

  PDF: {
    name: 'PDF',
    pathname: '/formularios/registrar/pdf',
  },

  MIPYME: {
    name: 'Registrar MiPyme',
    pathname: '/Gestionar MIPYME/Registro',
    roles: ['MIPYME'],
  },
  /* PANTALLAS IFIS */

  IFIFORMULARIOS: {
    name: 'Registrar Formulario de Pre-elegibilidad',
    pathname: '/IFI',
    roles: ['IFI'],
  },

  IFIREGISTRAR: {
    name: 'Registrar Formulario de Pre-elegibilidad',
    pathname: '/IFI/formularios/registrar',
    roles: ['IFI'],
  },

  IFIREGISTRAR_ELEGIBILIDAD: {
    name: 'Registrar Formulario de Elegibilidad',
    pathname: '/IFI/formularios/RegistrarElegibilidad',
    roles: ['IFI'],
  },
  IFIEDITARELEGIBILIDAD: {
    name: 'Editar Elegibilidad',
    pathname: '/IFI/formularios/EditarElegibilidad',
    roles: ['IFI'],
  },

  IFIVISTA: {
    name: 'Formularios Enviados',
    pathname: '/IFI/formularios/vista',
    roles: ['IFI'],
  },

  IFICONSTRUCTION: {
    pathname: '/IFI/construction',
  },

  IFIDETALLES: {
    name: 'Detalles De Formulario',
    pathname: '/IFI/formularios/vista/detalles',
    roles: ['IFI'],
  },

  IFIBORRADOR: {
    name: 'Formularios no Enviados',
    pathname: '/IFI/formularios/borrador',
    roles: ['IFI'],
  },

  IFIBORRADORELEGIBILIDAD: {
    name: 'Formularios no Enviados',
    pathname: '/IFI/formularios/borrador',
    roles: ['IFI'],
  },

  IFIEDITAR: {
    name: 'Formularios a completar',
    pathname: '/IFI/formularios/editar',
    roles: ['IFI'],
  },

  IFIPDF: {
    name: 'PDF',
    pathname: '/IFI/formularios/registrar/pdf',
  },

  IFIMIPYME: {
    name: 'Registrar MiPyme',
    pathname: '/IFI/Gestionar MIPYME/Registro',
    roles: ['IFI'],
  },

  IFIFORMSSENT: {
    name: 'Formularios Enviados por IFI',
    pathname: '/IFI/Formularios/Enviados',
    roles: ['IFI'],
  },

  MIPYMEFORMSENT: {
    name: 'Formularios Enviados por MIPYME',
    pathname: '/MIPYME/Formularios/Enviados',
    roles: ['MIPYME'],
  },
  REPRESENTARMIPYME: {
    name: 'Solicitud de Representar IFI',
    pathname: '/MIPYME/Solicitud/IFI',
    roles: ['MIPYME'],
  },
  NOTIFICACIONIFIMIPYME: {
    name: 'Notificación de Aceptar Representacion MIPYME',
    pathname: '/IFI/Solicitud/Notificaciones',
    roles: ['IFI'],
  },
  ELIMINARMIPYMESIFIS: {
    name: 'Eliminar Representacion MIPYME',
    pathname: '/IFI/Representacion/MIPYMES',
    roles: ['IFI'],
  },
  ELIMINARIFIMIPYMES: {
    name: 'Eliminar Representacion IFI',
    pathname: '/MIPYME/Representacion/IFI',
    roles: ['MIPYME'],
  },
  WORKSHOP: {
    name: 'Taller Inicial',
    pathname: '/Workshop',
    roles: ['MIPYME'],
  },
  SOLICITUDWORKSHOP: {
    name: 'Solicitud de Taller Inicial',
    pathname: '/Solicitud/Workshop',
    roles: ['IFI'],
  },
  ASISTENCIATECNICA: {
    name: 'Asistencia Tecnica',
    pathname: '/IFI/AsistenciaTécnica',
    roles: ['IFI'],
  },

  ASISTENCIATECNICAEDITAR: {
    name: 'Formularios a completar',
    pathname: '/IFI/AsistenciaTécnica/Editar',
    roles: ['IFI'],
  },

  ASISTENCIATECNICAENVIADOS: {
    name: 'Formularios enviados',
    pathname: '/AsistenciaTécnica/enviados',
    roles: ['MIPYME', 'IFI'],
  },
  MONITOREOYEVALUACION: {
    name: 'Monitoreo y Evaluación',
    pathname: '/IFI/MonitoreoYEvaluación',
    roles: ['IFI'],
  },
  CUESTIONARIOMONITOREOYEVALUACIONLISTADO: {
    name: 'Cuestionario Monitoreo y Evaluación',
    pathname: '/IFI/Cuestionario/MonitoreoYEvaluación/Listado',
    roles: ['IFI'],
  },

  CUESTIONARIOMONITOREOYEVALUACION: {
    name: 'Cuestionario Monitoreo y Evaluación',
    pathname: '/IFI/Cuestionario/MonitoreoYEvaluación',
    roles: ['IFI'],
  },
  MONITOREOYEVALUACIONENVIADOS: {
    name: 'Monitoreo y Evaluación Detalle',
    pathname: '/IFI/MonitoreoYEvaluación/Detalle',
    roles: ['IFI'],
  },
  REPRESENTACIONMIPYME: {
    name: 'Representación MIPYME',
    pathname: '/RepresentaciónMIPYME',
    roles: ['MIPYME', 'IFI'],
  },

  ACTIVATIONMIPYME: {
    name: 'Activación MIPYME',
    pathname: '/IFI/ActivaciónMIPYME',
    roles: ['IFI'],
  },
  /* FIN PANTALLAS IFIS */

  /* DESEMBOLSOS: {
    name: 'Gestor de desembolsos',
    pathname: '/desembolsos/solicitud',
    icon: 'carbon:chart-network',
    roles: ['SUPER', 'ADM', 'ADMOP', 'ADMROL', 'FENIX_'],
  },
  CONSULTA_DESEMBOLSOS: {
    name: 'Consulta de desembolsos',
    pathname: '/desembolsos/solicitud',
    roles: ['SUPER', 'ADM', 'ADMOP', 'ADMROL', 'FENIX_'],
  },
  CREAR_SOLICITUD_DESEMBOLSOS: {
    name: 'Crear solicitud de desembolsos',
    pathname: '/desembolsos/crear',
    roles: ['SUPER', 'ADM', 'ADMOP', 'ADMROL', 'FENIX_'],
  },
  SOLICITUD_DESEMBOLSO: {
    name: 'Crear solicitud de desembolsos',
    pathname: '/desembolsos/solicitud/:id',
    roles: ['SUPER', 'ADM', 'ADMOP', 'ADMROL', 'FENIX_'],
  },
  */
}

export default ROUTES
